<template>
  <div
    class="relative flex size-[44px] cursor-pointer items-center justify-center overflow-hidden rounded-full transition-colors hover:bg-[rgba(5,21,36,0.04)]"
    role="button"
    tabindex="0"
    :aria-label="label"
  >
    <Telegram />
    <div ref="telegramTargetRef" class="login-telegram-widget"></div>
  </div>
</template>

<script lang="ts">
const TELEGRAM_WIDGET_SRC = 'https://telegram.org/js/telegram-widget.js'
const TELEGRAM_DEFAULT_BOT = 'wikibitloginprod_bot'
const TELEGRAM_VIP_BOT = 'wikibitvipbot'

type TelegramAuthPayload = {
  auth_date?: number | string
  id?: number | string
  first_name?: string
  last_name?: string
  hash?: string
  photo_url?: string
}
</script>

<script setup lang="ts">
import Telegram from '~/assets/icon/telegram.svg'

defineProps<{
  label: string
}>()

const emit = defineEmits<{
  auth: [payload: TelegramAuthPayload]
}>()

const appStore = useAppStore()
const telegramTargetRef = ref<HTMLElement | null>(null)
const rendered = ref(false)

const telegramBotName = computed(() => {
  const host = appStore.host || (import.meta.client ? window.location.host : '')
  return host.includes('.wikibit.vip') ? TELEGRAM_VIP_BOT : TELEGRAM_DEFAULT_BOT
})

const ensureTelegramWidget = async () => {
  if (!import.meta.client || rendered.value) return

  await nextTick()

  const target = telegramTargetRef.value
  if (!target || rendered.value) return

  window.onWikiBitTelegramAuth = (payload: TelegramAuthPayload) => {
    emit('auth', payload)
  }

  target.innerHTML = ''
  const script = document.createElement('script')
  script.async = true
  script.src = TELEGRAM_WIDGET_SRC
  script.setAttribute('data-size', 'large')
  script.setAttribute('data-telegram-login', telegramBotName.value)
  script.setAttribute('data-request-access', 'write')
  script.setAttribute('data-onauth', 'window.onWikiBitTelegramAuth(user)')
  target.appendChild(script)
  rendered.value = true
}

onMounted(() => {
  void ensureTelegramWidget()
})
</script>

<style scoped>
.login-telegram-widget {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  opacity: 0.01;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-telegram-widget :deep(iframe) {
  transform: scale(1.5);
  cursor: pointer;
  pointer-events: auto;
}
</style>
